export const IPHONE_7_SCREEN_HEIGHT_BREAKPOINT = 667
